import { createFileRoute } from '@tanstack/react-router';

type Search = {
  v?: string;
  email?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/user-invite_/$nonceToken_/location_/$locationId')({
  validateSearch: (search: Search) => search,
});
